import { render, staticRenderFns } from "./More.vue?vue&type=template&id=4940709c&scoped=true&"
import script from "./More.vue?vue&type=script&lang=js&"
export * from "./More.vue?vue&type=script&lang=js&"
import style0 from "@/common.css?vue&type=style&index=0&id=4940709c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940709c",
  null
  
)

export default component.exports